import {Directive, ElementRef, Input, OnChanges, Renderer2, SimpleChanges} from '@angular/core';
@Directive({
  selector: '[libDefaultPhoto]'
})
export class DefaultPhotoDirective implements OnChanges {
  @Input('libDefaultPhoto') src!: string;
  @Input() default = 'assets/no-profile/no-profile-icon.png';
  constructor(private el: ElementRef, private renderer: Renderer2) {
  }
  ngOnChanges(changes: SimpleChanges) {
    if ('src' in changes) {
      this.renderer.setAttribute(this.el.nativeElement, 'src', this.src ? this.src : this.default);
    }
  }
}
